import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b8cc07ac&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cc07ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8cc07ac')) {
      api.createRecord('b8cc07ac', component.options)
    } else {
      api.reload('b8cc07ac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b8cc07ac&scoped=true&", function () {
      api.rerender('b8cc07ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/QuotationLcl/index.vue"
export default component.exports